/** Google Ads conversion (gtag.js).
 * Fires `gtag('event', 'conversion', ...)` only when a conversion label has been
 * configured via REACT_APP_GOOGLE_ADS_CONVERSION_LABEL (format: `AW-XXXX/LABEL`).
 * If the label is not set the call is a safe no-op so we never fire an
 * invalid `send_to`. Enhanced Conversions user data is passed if available.
 */
export function trackGoogleAdsConversion({ value = 1, currency = "USD", enhancedUserData } = {}) {
  const sendTo = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (!sendTo) return; // No label configured yet — do not invent one.
  window.gtag("event", "conversion", {
    send_to: sendTo,
    value,
    currency,
  });
  if (enhancedUserData) {
    // Google Ads Enhanced Conversions via gtag.js
    window.gtag("set", "user_data", enhancedUserData);
  }
}
